/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forside_Quotes_PlaceholderInputs */

const da_forside_quotes_placeholder = /** @type {(inputs: Forside_Quotes_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eksempler – citater fra rigtige lærere kommer snart`)
};

/** @type {(inputs: Forside_Quotes_PlaceholderInputs) => LocalizedString} */
const en_forside_quotes_placeholder = da_forside_quotes_placeholder;

/**

* @param {Forside_Quotes_PlaceholderInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const forside_quotes_placeholder = /** @type {((inputs?: Forside_Quotes_PlaceholderInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forside_Quotes_PlaceholderInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forside_quotes_placeholder(inputs)
	return /** @type {LocalizedString} */ ("Eksempler – citater fra rigtige lærere kommer snart")
});